import { endpoints } from '../api/endpoints'
import { exportTypes } from '../constantes/actionTypes'
import { createMiddlewareAction } from './createMiddlewareAction'

export const exportActions = {
  exportCSV: (entity) =>
    createMiddlewareAction({
      successType: exportTypes.EXPORT_CSV_SUCCESS,
      failureType: exportTypes.EXPORT_CSV_FAILURE,
      method: 'GET',
      endpoint: endpoints.EXPORT_CSV(entity),
    }),
}
